import React from "react";
import { setData } from "rivals/shared/utils/qa";
import { Props } from "./types";

export const FuturecastLogo = ({
  height,
  philter = "",
  variant = "dark",
  ...props
}: Props): JSX.Element | null => {
  const imgSrc =
    variant === "dark"
      ? "/static/images/futurecast_blk.png"
      : "/static/images/futurecast_wht.png";

  return (
    <img
      alt="futurecast"
      src={imgSrc}
      style={{ height }}
      {...setData(philter, "futurecast-logo")}
      {...props}
    />
  );
};

export default FuturecastLogo;
